export const moonriverZaps = [
  {
    // Solarbeam
    zapAddress: '0xb0F9c6FBcfE226EEAD3AE8b019ce4666cE223a78',
    ammRouter: '0xAA30eF758139ae4a7f798112902Bf6d65612045f',
    ammFactory: '0x049581aEB6Fe262727f290165C29BDAB065a1B68',
    ammPairInitHash: '0x9a100ded5f254443fbd264cb7e87831e398a8b642e061670a9bc35ba27293dbf',
  },
  {
    //Sushi
    zapAddress: '0x853d81dAC9cA251784f314043f0c7CB102328FAb',
    ammRouter: '0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506',
    ammFactory: '0xc35DADB65012eC5796536bD9864eD8773aBc74C4',
    ammPairInitHash: '0xe18a34eb0e04b04f7a0ac29a6e80748dca96319b42c54d679cb821dca90c6303',
  },
];
